import { Graph } from '../lib/graph'
import { Node } from '../lib/node'
import { Edge } from '../lib/edge'
import { DirectedEdge } from './directed-edge';

/**
 * Simple directed graphs are directed graphs that have no loops 
 * (arrows that connect vertices to themselves) and no multiple arrows with same source and target nodes.
 */
export abstract class SimpleDirectedGraph extends Graph {
  

    /**
     * 
     *@param from , the Node from which the edge originates
     *@param to, the destination of the new added Edge
     *
     *Precondition: from != null && to != null
     *Postcondition: from == to => (from.isNeighbor(to) == false && to.isNeighbor(from) == false)
     *                from != to && !pre(existsEdge(to,from)) => existsEdge(to,from) 
     */
    addEdge(from: Node, to: Node) {
        if (from == to)
            return;

        //Node has been deleted, hence cant be used to connect
        if (this.nodes.indexOf(from) == -1 || this.nodes.indexOf(to) == -1){
            return;
        }

        from.addNeighbor(to);
        if(!this.existsEdge(from,to)){
            this.edges.push(new DirectedEdge(from,to));
        }
        this.update();

    }

    protected deleteEdge(from: Node, to: Node) { 
        if(this.existsEdge(from,to)){
            var delEdge : Edge = this.getEdge(from,to);
            const index = this.edges.indexOf(delEdge, 0);
            if (index > -1) {
                this.edges.splice(index, 1);
            } 
        }
        from.removeNeighbor(to);
        this.update();
    }

    protected existsEdge(fromNode:Node, toNode:Node):boolean{
        var exists: boolean = false;

        this.edges.forEach(edge => {
            if(edge.getFromNode() == fromNode && edge.getToNode() == toNode){
                exists = true;
            }
        })

        return exists;
    }

    getEdge(fromNode: Node, toNode:Node): Edge{
       var searchEdge: Edge = null;
       this.edges.forEach(edge => {
            if (edge.getFromNode().getId() == fromNode.getId() && edge.getToNode().getId() == toNode.getId()) {
                searchEdge = edge;;
            }
        });
        return searchEdge;
    }

    protected logAllEdgesAndNodes(){
        this.nodes.forEach(node => {
            console.log(node.toString());
        })

        this.edges.forEach(edge => {
            console.log(edge.toString());
        })
    }


}
